import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DualRing } from "react-loading-io";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import BackButton from "../Components/backButton";
import ModalRetakeAsessory from "../Components/modalRetakeAsessory";
import alert from "../Resources/img/icon-alert-yellow.png";
import persons from "../Resources/img/home_girl.png";
import { addRecommended } from "../Store/recommended/actions";
import { modalError } from "../Store/simulate/actions";
import { getDataObtener, validateWatchListV2 } from "../Utils/utils";
import { removeAssured, updateAssured } from "./../Store/data/actions";
import { addIdProspecto } from "./../Store/prospect/actions";
import ModalInformative from "./ModalInformative";
import AlertMessage from "./alertMessage";
import ErrorCustom from "./errorCustom";
import Loading from "./loading";
import WapperGetClient from "./wapperGetClient";
import ModalTerminos from "./ModalTerminos";
import ModalPoliticas from "./ModalPoliticas";
import ModalUnauthorizeToQuote from "./modalUnauthorizeToQuote"
import useUserCanQuote from "../customHook/useUserCanQuote"
import { clientsType } from '../Utils/constants';
import ModalWhatchListV2 from "./modalWhatchListV2";

const HookFormAsuredData = () => {
  const userCanQuote = useUserCanQuote();
  const dispatch = useDispatch();
  const history = useHistory();
  const [blackList, setBlackList] = useState(false);
  const [yellowList, setYellowList] = useState(false);
  const {
    handleSubmit,
    register,
    errors,
    getValues,
    setError,
    clearError,
    setValue,
    watch
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState();
  const [errorSubmit, setErrorSubmit] = useState(false);
  const clientType = "DATOS DEL ASEGURADO";
  const [dps, setDps] = useState(false);
  const channel = useSelector((state) => state.login.channel);
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [openModalMessagePDP, setOpenModalMessagePDP] = useState(false);
  const [openModalMessagePCC, setOpenModalMessagePCC] = useState(false);
  const [watchlist, setWatchlist] = useState(false);
  const [terceros, setTerceros] = useState();
  const [hasValidClientToken, setHasValidClientToken] = useState(false);
  const [dataPerfil, setDataPerfil] = useState({
    name: "",
    date: "",
    perfil: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [unauthorizeToQuote, setUnauthorizeToQuote] = useState(false);
  const [openUnauthorizeToQuote, setOpenUnauthorizeToQuote] = useState(false);
  const [dataSubmit, setDataSubmit] = useState(null);

  useEffect(() => { 
    const result = !hasValidClientToken && !userCanQuote && !loading;
    setUnauthorizeToQuote(result);
  }, [userCanQuote, hasValidClientToken, loading]);

  useEffect(() => { 
    setOpenUnauthorizeToQuote(unauthorizeToQuote);
  }, [unauthorizeToQuote]);    

  const getCheckAssured = async (data) => {
    setLoading(true);
    try {
      setDataPerfil({
        name: "",
        date: "",
        perfil: "",
      });
      let response = await getDataObtener(data);
      setLoading(false);
      if (response.payload.data.resultadoPerfilamiento !== undefined) {
        const { portafoliosSugeridos } =
          response.payload.data.resultadoPerfilamiento;
        const { valores } = portafoliosSugeridos[0];
        dispatch(addIdProspecto(response.payload.idProspecto));
        dispatch(
          addRecommended({
            product: response.payload.data.resultadoPerfilamiento.producto,
            investmentProfile:
              response.payload.data.resultadoPerfilamiento.perfil,
            portafolios: valores[0].portafolios[0].descripcion,
          })
        );
        let perfil = { ...dataPerfil };
        perfil.name = data.names;
        perfil.date = response.payload.fechaModificacion;
        perfil.perfil = response.payload.data.resultadoPerfilamiento.perfil;
        setDataPerfil(perfil);
        if (terceros === null) {
          dispatch(modalError(true));
        } else {
          setOpenModalMessage(true);
        }
      } else {
        if (terceros === null) {
          dispatch(modalError(true));
        } else {
          history.push("/perfil-de-inversion");
        }
      }
    } catch (ex) {
      setLoading(false);
      throw ex;
    }
  };

  const onSubmit = async (values) => {
    if (unauthorizeToQuote) {
      setOpenUnauthorizeToQuote(true);
      return;
    }
    const data = {
      ...values,
      channel,
      isChecked,
      clientType,
    };
    setDataSubmit(data);
    dispatch(removeAssured());
    dispatch(updateAssured(data));

    try {
      setIsLoading(true);
      const { nroDoc, typeDoc, pep } = data;
      const watchlistv2 = typeDoc != '4' ? await validateWatchListV2(nroDoc, typeDoc, pep) : await validateWatchListV2(nroDoc, typeDoc);
      const {
        data: { lista, areas },
      } = watchlistv2;
      dispatch(updateAssured({...data, dataPlaft: {areas, lista}}));
      if (lista) {
        setBlackList(lista === "black");
        setYellowList(lista === "yellow");
        setWatchlist(lista !== "white");
        setIsLoading(false);
        if (lista === "black") return;
        if (lista === "white") defineAsuredAction(data);
      }
      
    } catch (error) {
      setErrorSubmit(true);
      console.error(error);
      setIsLoading(false);
    }
  };
  
  const defineAsuredAction = async (data) => {
    if (!isChecked) {
      if(data){
        await getCheckAssured(data);
      } else {
        await getCheckAssured(dataSubmit);
      }
    }
  
    if (isChecked) {
      history.push("/datos-del-contratante");
    }
  }

  const handleOnChange = (e) => {
    setIsChecked(e.currentTarget.checked);
    setTimeout(() => {
      setErrorSubmit(false);
    }, 4500);
  };

  const changeInvestmentProfile = () => {
    setOpenModalMessage(false);
    history.push("/perfil-de-inversion");
  };
  const continueInvestmentProfile = () => {
    setOpenModalMessage(false);
    history.push("/productos");
  };

  useEffect(() => {
    if(errorSubmit) window.scrollTo(0, 0);  

  }, [errorSubmit]);

  return (
    <div className="wrap">
      <div className="content-box">
        <div className="adForm-container">
          <div className="adForm adForm--b product-view">
            <div className="adForm__container-titles">
              <BackButton />
              <p className="adForm__container-titles__title">
                Datos del <span>asegurado</span>
              </p>
              <p className="adForm__container-titles__sub-title">
                Ingresa el número de documento
              </p>
            </div>
            {errorSubmit && (
              <AlertMessage
                icono={alert}
                background="#FFEFD8"
                mensaje="Ha ocurrido un problema, intentar salir de la sesión y volver a entrar. Si persiste favor comunicarlo."
              />
            )}
            <br />
            <form onSubmit={handleSubmit(onSubmit)} className="adForm__form">
              <WapperGetClient
                register={register}
                getValues={getValues}
                errors={errors}
                clientType={clientsType.INSURED}
                setLoading={setLoading}
                setError={setError}
                clearError={clearError}
                setValue={setValue}
                setDps={setDps}
                hasDNI={true}
                setTerceros={setTerceros}
                watch={watch}
                setHasValidClientToken={setHasValidClientToken}
              />
              <div className="wapperGetClient__group">
                <div className="wapperGetClient__group__item">
                  <label>
                    <input
                      name={`checkbox1`}
                      className="filled-in"
                      type="checkbox"
                      defaultChecked={false}
                      onChange={(e) => handleOnChange(e)}
                    />
                    <span className="checkbox-name">
                      Marca si el contratante es diferente al asegurado
                    </span>
                  </label>
                </div>
                <div className="wapperGetClient__group__item">
                  <label>
                    <input
                      name={`LPDP`}
                      className="filled-in"
                      type="checkbox"
                      defaultChecked={false}
                      ref={register({
                        validate: {
                          required: (value) => {
                            if (!value)
                              return "Es obligatorio aceptar la política Protección de Datos Personales.";
                            return true;
                          },
                        },
                      })}
                    />
                    <span htmlFor="LPDP" className="checkbox-name">
                      Acepto la Política de aceptación de{" "}
                      <u
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenModalMessagePDP(true);
                        }}
                      >
                        Protección de Datos Personales
                      </u>
                      <ErrorCustom errors={errors} name="LPDP" />
                    </span>
                  </label>
                </div>
                <div className="wapperGetClient__group__item">
                  <label>
                    <input
                      name={`CC`}
                      className="filled-in"
                      type="checkbox"
                      defaultChecked={false}
                      ref={register({
                        validate: {
                          required: (value) => {
                            return true;
                          },
                        },
                      })}
                    />
                    <span htmlFor="CC" className="checkbox-name">
                      Acepto la{" "}
                      <u
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenModalMessagePCC(true);
                        }}
                      >
                        Política Comunicaciones Comerciales
                      </u>
                    </span>
                    <ErrorCustom errors={errors} name="CC" />
                  </label>
                </div>
              </div>
              <div className="adForm__form__btnew-group align-btn">
                <button id="button_quote_vas" type="submit" className="btnew">
                  CONTINUAR
                </button>
              </div>
            </form>
            {loading && (
              <div className="loading-field">
                <DualRing size={50} />
              </div>
            )}
          </div>
          <div className="person">
            <div className="person__img">
              <img src={persons} />
            </div>
          </div>
        </div>
        <ModalUnauthorizeToQuote
          open={openUnauthorizeToQuote}
          setOpen={setOpenUnauthorizeToQuote}
        />
        <ModalRetakeAsessory
          open={openModalMessage}
          setOpen={setOpenModalMessage}
          title={
            dataPerfil.name + " YA TIENE UN PERFIL DE INVERSIÓN REGISTRADO"
          }
          subtitle="Perfil de inversión"
          investmentProfile={dataPerfil.perfil}
          registerDate={"Registrado el " + dataPerfil.date}
          firstButtonText="CAMBIAR"
          secondButtonText="CONTINUAR"
          firstButtonFunction={changeInvestmentProfile}
          secondButtonFunction={continueInvestmentProfile}
        />
        <ModalWhatchListV2 
          watchlist={watchlist} 
          setWatchlist={setWatchlist}
          blackList={blackList}  
          yellowList={yellowList}
          formType={"asured"}
          actionAsured={defineAsuredAction}
        />
        <ModalInformative title="CLIENTE NO CREADO" text="1" />
        <ModalTerminos
          openModalMessagePDP={openModalMessagePDP}
          setOpenModalMessagePDP={setOpenModalMessagePDP}
        />
        <ModalPoliticas
          openModalMessagePCC={openModalMessagePCC}
          setOpenModalMessagePCC={setOpenModalMessagePCC}
        />
        {isLoading && <Loading />}
      </div>
    </div>
  );
};

export default HookFormAsuredData;
